import { render, staticRenderFns } from "./EmpSettingsAddUser.vue?vue&type=template&id=c8e495a2&"
import script from "./EmpSettingsAddUser.vue?vue&type=script&lang=js&"
export * from "./EmpSettingsAddUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports